import { render, staticRenderFns } from "./ContaEscrow.vue?vue&type=template&id=e3da6ac4&"
import script from "./ContaEscrow.vue?vue&type=script&lang=js&"
export * from "./ContaEscrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports